import React from "react";
import { Space } from "antd";
import CusPageHeader from "components/Molecules/header";
import Page from "components/Molecules/page";
import Tabs from "components/Organisms/tabs";
import { useNavigate } from "react-router-dom";
import StatisticsGroup from "components/Molecules/statistics-group";
import { getReviewStats } from "../../constants";
import { ReviewTable } from "../../components/ReviewTable";
import styled from "@emotion/styled";
import { useFetchReviewerOverview, useListReview } from "pages/Reviews/api";
import { withFiltersOptions } from "HOCs/withFiltersOptions";
import omit from "lodash/omit";
import { MainLayout } from "components/Organisms/layouts";

const FullWidth = styled(Space)`
  width: 100%;
`;
const Home = withFiltersOptions(({ filters }: any) => {
  const navigate = useNavigate();
  const overview = useFetchReviewerOverview();
  const [waitingForReviews, onChangeTask] = useListReview("waiting_for_review");

  const [allTask, onChangeAllTask] = useListReview("");

  const onChange = (
    pagination: { current: number; pageSize: number },
    filtered: Record<string, any>,
    sorted: Record<string, any>,
    extra: { action: string; currentDataSource: Array<any> }
  ) => {
    onChangeTask(
      pagination,
      { ...filtered, status: ["waiting_for_review"] },
      sorted,
      extra
    );
  };
  const onChangeJob = (
    pagination: { current: number; pageSize: number },
    filtered: Record<string, any>,
    sorted: Record<string, any>,
    extra: { action: string; currentDataSource: Array<any> }
  ) => {
    onChangeAllTask(
      pagination,
      { ...filtered, status: ["waiting_for_review"] },
      sorted,
      extra
    );
  };
  return (
    <>
      <MainLayout>
        <CusPageHeader title="Home"></CusPageHeader>
        <Page>
          <FullWidth direction="vertical" size={32}>
            <Space direction="vertical" size={[0, 3]}>
              <h2>Overview</h2>
              <StatisticsGroup
                containerProps={{
                  size: 32,
                }}
                stats={getReviewStats(navigate, overview.data || {}) as any}
              ></StatisticsGroup>
            </Space>
            <Space direction="vertical" size={[0, 12]}>
              <h2>My Jobs</h2>
            </Space>
            <Tabs
              tabs={[
                {
                  key: "todo",
                  tab: "Todo",
                  content: (
                    <ReviewTable
                      scroll={{ x: true }}
                      loading={waitingForReviews.isLoading}
                      dataSource={(waitingForReviews as any)?.data?.list ?? []}
                      defaultFilteredValue={{ status: ["waiting_for_review"] }}
                      filters={omit(filters, "status")}
                      onChange={onChange}
                      pagination={{
                        total: (waitingForReviews as any)?.data?.total ?? 0,
                      }}
                    ></ReviewTable>
                  ),
                },
                {
                  key: "myJobs",
                  tab: "My jobs",
                  content: (
                    <ReviewTable
                      scroll={{ x: true }}
                      dataSource={allTask?.data?.list ?? []}
                      filters={filters}
                      loading={allTask.isLoading}
                      onChange={onChangeJob}
                      pagination={{
                        total: (allTask as any)?.data?.total ?? 0,
                      }}
                    ></ReviewTable>
                  ),
                },
              ]}
            ></Tabs>
          </FullWidth>
        </Page>
      </MainLayout>
    </>
  );
});

export default Home;
